/** 납품실적 표 행 (NO, 발주처, 품목, 금액). 연도에 따라 현장명 포함 */
export type DeliveryRow = {
  no: number;
  발주처: string;
  품목: string;
  /** 2022 등 자료에 현장명이 있을 때만 사용 */
  현장명?: string;
  금액: string;
};

export const deliveryList2025: readonly DeliveryRow[] = [
  { no: 1, 발주처: '삼성물산(주)에버랜드리조트', 품목: '안전용품', 금액: '81,664,000' },
  { no: 2, 발주처: '주식회사 근우', 품목: '안전용품', 금액: '183,361,000' },
  { no: 3, 발주처: '비전엔지니어링', 품목: '안전용품', 금액: '9,231,500' },
  { no: 4, 발주처: '(주)한국종합기술', 품목: '안전용품', 금액: '15,702,500' },
  { no: 5, 발주처: '엘앤케이경원건설(주)', 품목: '안전용품', 금액: '22,570,000' },
  { no: 6, 발주처: '새암조경주식회사', 품목: '안전용품', 금액: '19,705,500' },
  { no: 7, 발주처: '신도이앤씨(주)', 품목: '안전용품', 금액: '58,215,500' },
  { no: 8, 발주처: '주식회사 대경이앤에스', 품목: '안전용품', 금액: '66,538,600' },
  { no: 9, 발주처: '신한열기(주)', 품목: '안전용품', 금액: '37,243,500' },
  { no: 10, 발주처: '주식회사 원이앤에스', 품목: '안전용품', 금액: '17,684,200' },
  { no: 11, 발주처: '대은건설 주식회사', 품목: '안전용품', 금액: '11,636,000' },
  { no: 12, 발주처: '(주)하우징케어', 품목: '안전용품', 금액: '9,227,200' },
  { no: 13, 발주처: '에너지엑스 주식회사', 품목: '안전용품', 금액: '12,221,600' },
  { no: 14, 발주처: '태성종합건설 (주)', 품목: '안전용품', 금액: '16,511,000' },
  { no: 15, 발주처: '주식회사 케이티', 품목: '안전용품', 금액: '9,069,100' },
  { no: 16, 발주처: '경희이코텍주식회사', 품목: '안전용품', 금액: '10,622,000' },
  { no: 17, 발주처: '두원이에프씨(주)', 품목: '안전용품', 금액: '25,692,000' },
  { no: 18, 발주처: '천지 주식회사', 품목: '안전용품', 금액: '19,742,800' },
  { no: 19, 발주처: '주식회사 이에프', 품목: '안전용품', 금액: '7,063,000' },
  { no: 20, 발주처: '(주)한성엔지니어링', 품목: '안전용품', 금액: '10,058,000' },
  { no: 21, 발주처: '세진전력(주)', 품목: '안전용품', 금액: '11,492,500' },
  { no: 22, 발주처: '두손 주식회사', 품목: '안전용품', 금액: '9,372,000' },
  { no: 23, 발주처: '성정헌건설 주식회사', 품목: '안전용품', 금액: '9,644,000' },
  { no: 24, 발주처: '그 외업체(87개)', 품목: '안전용품', 금액: '243,504,563' },
] as const;

export const deliveryList2024: readonly DeliveryRow[] = [
  { no: 1, 발주처: '삼성물산(주)에버랜드리조트', 품목: '안전용품', 금액: '90,981,800' },
  { no: 2, 발주처: '주식회사 근우', 품목: '안전용품', 금액: '120,423,000' },
  { no: 3, 발주처: '비전엔지니어링', 품목: '안전용품', 금액: '104,260,500' },
  { no: 4, 발주처: '(주)한국종합기술', 품목: '안전용품', 금액: '30,411,000' },
  { no: 5, 발주처: '(주)에스원', 품목: '안전용품', 금액: '10,828,758' },
  { no: 6, 발주처: '신도이앤씨(주)', 품목: '안전용품', 금액: '40,416,500' },
  { no: 7, 발주처: '주식회사 대경이앤에스', 품목: '안전용품', 금액: '62,125,100' },
  { no: 8, 발주처: '신한열기(주)', 품목: '안전용품', 금액: '82,788,500' },
  { no: 9, 발주처: '주식회사 원이앤에스', 품목: '안전용품', 금액: '38,705,000' },
  { no: 10, 발주처: '대은건설 주식회사', 품목: '안전용품', 금액: '36,430,000' },
  { no: 11, 발주처: '(주)한영씨엠씨', 품목: '안전용품', 금액: '10,101,500' },
  { no: 12, 발주처: '(주)컴피아', 품목: '안전용품', 금액: '25,594,000' },
  { no: 13, 발주처: '(주)한성엔지니어링', 품목: '안전용품', 금액: '32,017,000' },
  { no: 14, 발주처: '주식회사 케이티', 품목: '안전용품', 금액: '7,635,000' },
  { no: 15, 발주처: '경희이코텍주식회사', 품목: '안전용품', 금액: '22,945,000' },
  { no: 16, 발주처: '두원이에프씨(주)', 품목: '안전용품', 금액: '8,757,000' },
  { no: 17, 발주처: '천지 주식회사', 품목: '안전용품', 금액: '9,747,520' },
  { no: 18, 발주처: '주식회사 이에프', 품목: '안전용품', 금액: '7,785,000' },
  { no: 19, 발주처: '세진전력(주)', 품목: '안전용품', 금액: '27,520,050' },
  { no: 20, 발주처: '일성건설(주)', 품목: '안전용품', 금액: '3,303,000' },
  { no: 21, 발주처: '케이엘지건설 주식회사', 품목: '안전용품', 금액: '19,340,000' },
  { no: 22, 발주처: '(주)세영이앤지', 품목: '안전용품', 금액: '15,389,000' },
  { no: 23, 발주처: '주식회사성원이앤씨', 품목: '안전용품', 금액: '13,034,000' },
  { no: 24, 발주처: '그 외업체(99개)', 품목: '안전용품', 금액: '355,782,222' },
] as const;

export const deliveryList2023: readonly DeliveryRow[] = [
  { no: 1, 발주처: '에스앤마이코퍼레이션', 품목: '안전용품', 금액: '182,966,218' },
  { no: 2, 발주처: '주식회사 근우', 품목: '안전용품', 금액: '166,192,900' },
  { no: 3, 발주처: '비전엔지니어링', 품목: '안전용품', 금액: '116,495,055' },
  { no: 4, 발주처: '(주) 한국종합기술', 품목: '안전용품', 금액: '75,208,000' },
  { no: 5, 발주처: '(주) 에스원', 품목: '안전용품', 금액: '60,439,020' },
  { no: 6, 발주처: '한재산업개발 (주)', 품목: '안전용품', 금액: '55,776,500' },
  { no: 7, 발주처: '신도이앤씨(주)', 품목: '안전용품', 금액: '50,776,500' },
  { no: 8, 발주처: '주식회사 대경이앤에스', 품목: '안전용품', 금액: '47,669,200' },
  { no: 9, 발주처: '신한열기 (주)', 품목: '안전용품', 금액: '37,875,500' },
  { no: 10, 발주처: '주식회사 원이앤에스', 품목: '안전용품', 금액: '31,877,900' },
  { no: 11, 발주처: '대은건설 주식회사', 품목: '안전용품', 금액: '31,537,000' },
  { no: 12, 발주처: '(주) 한영씨엠씨', 품목: '안전용품', 금액: '28,727,000' },
  { no: 13, 발주처: '(주) 컴피아', 품목: '안전용품', 금액: '28,406,000' },
  { no: 14, 발주처: '(주)대근지앤씨', 품목: '안전용품', 금액: '28,404,000' },
  { no: 15, 발주처: '주식회사 케이티', 품목: '안전용품', 금액: '25,120,000' },
  { no: 16, 발주처: '경희이코텍주식회사', 품목: '안전용품', 금액: '22,096,480' },
  { no: 17, 발주처: '두원이엔프씨 (주)', 품목: '안전용품', 금액: '21,553,000' },
  { no: 18, 발주처: '천지 주식회사', 품목: '안전용품', 금액: '21,392,800' },
  { no: 19, 발주처: '주식회사 이에프', 품목: '안전용품', 금액: '16,997,500' },
  { no: 20, 발주처: '(주) 선미인터내셔널', 품목: '안전용품', 금액: '16,577,000' },
  { no: 21, 발주처: '세진전력(주)', 품목: '안전용품', 금액: '15,592,500' },
  { no: 22, 발주처: '일성건설(주)', 품목: '안전용품', 금액: '14,599,000' },
  { no: 23, 발주처: '형인산업개발 (주)', 품목: '안전용품', 금액: '13,595,000' },
  { no: 24, 발주처: '그 외업체(109개)', 품목: '안전용품', 금액: '363,792,400' },
] as const;

export const deliveryList2022: readonly DeliveryRow[] = [
  { no: 1, 발주처: '주식회사 근우', 품목: '안전용품', 현장명: '신라호텔외', 금액: '113,328,200' },
  { no: 2, 발주처: '선미인터내셔널', 품목: '안전용품', 현장명: '멀티캠퍼스역삼외', 금액: '95,217,500' },
  { no: 3, 발주처: '일성건설 (주)', 품목: '안전용품', 현장명: '트루엘에코시티외', 금액: '65,633,500' },
  { no: 4, 발주처: '한영씨엠씨', 품목: '안전용품', 현장명: '청량리롯데건설외', 금액: '49,759,500' },
  { no: 5, 발주처: '비전엔지니어링', 품목: '안전용품', 현장명: '화성데이터센터외', 금액: '39,897,900' },
  { no: 6, 발주처: '두원이엔프씨', 품목: '안전용품', 현장명: '오산원동 2공구외', 금액: '32,609,200' },
  { no: 7, 발주처: '컴피아', 품목: '안전용품', 현장명: '천호정비공사외', 금액: '17,569,500' },
  { no: 8, 발주처: '신한열기', 품목: '안전용품', 현장명: '현대제철순천공장외', 금액: '17,525,400' },
  { no: 9, 발주처: '일촌나눔하우징', 품목: '안전용품', 현장명: '중앙보훈병원외', 금액: '15,879,000' },
  { no: 10, 발주처: '세진전력', 품목: '안전용품', 현장명: '쿠팡외', 금액: '15,646,100' },
  { no: 11, 발주처: '대근지앤씨', 품목: '안전용품', 현장명: '한양수자인외', 금액: '15,574,000' },
  { no: 12, 발주처: '에스케이임업', 품목: '안전용품', 현장명: '미천농장외', 금액: '15,129,800' },
  { no: 13, 발주처: '명성에스앤에프', 품목: '안전용품', 현장명: '농협하나로마트외', 금액: '14,211,000' },
  { no: 14, 발주처: '국제전설', 품목: '안전용품', 현장명: '훈민중학교외', 금액: '12,838,000' },
  { no: 15, 발주처: '새빛전력', 품목: '안전용품', 현장명: '한전저압단가외', 금액: '12,509,000' },
  { no: 16, 발주처: '하우징케어', 품목: '안전용품', 현장명: '서울역사박물관외', 금액: '11,542,000' },
  { no: 17, 발주처: '대은건설', 품목: '안전용품', 현장명: '해성여고외', 금액: '10,589,500' },
  { no: 18, 발주처: '성화이엔씨', 품목: '안전용품', 현장명: '', 금액: '10,503,000' },
  { no: 19, 발주처: '케미티', 품목: '안전용품', 현장명: '', 금액: '9,339,900' },
  { no: 20, 발주처: '예일이앤시', 품목: '안전용품', 현장명: '지제1초등학교', 금액: '9,153,500' },
  { no: 21, 발주처: '샤론일렉콤', 품목: '안전용품', 현장명: '신울산S/S 354kv외', 금액: '9,027,000' },
  { no: 22, 발주처: '대흥토건', 품목: '안전용품', 현장명: '송정중학교외', 금액: '8,745,000' },
  { no: 23, 발주처: '원이앤에스', 품목: '안전용품', 현장명: '', 금액: '8,492,000' },
  { no: 24, 발주처: '그 외업체(96개)', 품목: '안전용품', 현장명: '', 금액: '217,467,300' },
] as const;

export const deliveryList2021: readonly DeliveryRow[] = [
  { no: 1, 발주처: '삼성물산(주)리조트', 품목: '안전용품', 현장명: '호텔신라외', 금액: '129,789,600' },
  { no: 2, 발주처: '일성건설(주)', 품목: '안전용품', 현장명: '가재울트루엘에코시티외', 금액: '77,198,100' },
  { no: 3, 발주처: '(주)선미인터내셔날', 품목: '안전용품', 현장명: '삼성전자서초사옥외', 금액: '71,903,100' },
  { no: 4, 발주처: '(주)근우', 품목: '안전용품', 현장명: '삼성서울병원외', 금액: '68,875,400' },
  { no: 5, 발주처: '두원이엔에프씨(주)', 품목: '안전용품', 현장명: '오산물류센터외', 금액: '46,224,600' },
  { no: 6, 발주처: '신한열기(주)', 품목: '안전용품', 현장명: '지역난방공사외', 금액: '42,958,400' },
  { no: 7, 발주처: '(주)한영씨엠씨', 품목: '안전용품', 현장명: '인천공항외', 금액: '33,823,900' },
  { no: 8, 발주처: '샤론일렉콤(주)', 품목: '안전용품', 현장명: '신울산 현장', 금액: '31,842,800' },
  { no: 9, 발주처: '세진전력(주)', 품목: '안전용품', 현장명: '리움미술관외', 금액: '31,756,600' },
  { no: 10, 발주처: '(주)뉴보텍', 품목: '안전용품', 현장명: '익산현장외', 금액: '26,472,600' },
  { no: 11, 발주처: '(주)청해진건설', 품목: '안전용품', 현장명: '가재울트루엘에코시티외', 금액: '23,485,000' },
  { no: 12, 발주처: '위드제이산업 주식회사', 품목: '안전용품', 현장명: '청담초등학교외', 금액: '20,306,000' },
  { no: 13, 발주처: '일촌나눔하우징주식회사', 품목: '안전용품', 현장명: '중계주민센터외', 금액: '19,219,200' },
  { no: 14, 발주처: '대은건설 주식회사', 품목: '안전용품', 현장명: '송곡여중외', 금액: '17,938,200' },
  { no: 15, 발주처: '(주)새빛전력', 품목: '안전용품', 현장명: '한전저압단가외', 금액: '17,860,700' },
  { no: 16, 발주처: '에스케이임업주식회사', 품목: '안전용품', 현장명: '파라다이스시티외', 금액: '17,808,400' },
  { no: 17, 발주처: '솔찬조경 주식회사', 품목: '안전용품', 현장명: '대방노블레스외', 금액: '17,337,100' },
  { no: 18, 발주처: '예인미앤시 주식회사', 품목: '안전용품', 현장명: '지제1초외', 금액: '15,206,600' },
  { no: 19, 발주처: '성진미앤씨(주)', 품목: '안전용품', 현장명: '삼성전자화성외', 금액: '14,731,700' },
  { no: 20, 발주처: '주식회사비전엔지니어링', 품목: '안전용품', 현장명: '수원DC현장외', 금액: '14,569,000' },
  { no: 21, 발주처: '태양방재산업주식회사', 품목: '안전용품', 현장명: '판교알파돔외', 금액: '12,519,600' },
  { no: 22, 발주처: '(주)하우징케어', 품목: '안전용품', 현장명: '노원청소년복지센터외', 금액: '11,407,000' },
  { no: 23, 발주처: '한성건설 주식회사', 품목: '안전용품', 현장명: '신당동현장외', 금액: '10,706,800' },
  { no: 24, 발주처: '그 외업체(111개)', 품목: '안전용품', 현장명: '', 금액: '251,490,000' },
] as const;

export const deliveryList2020: readonly DeliveryRow[] = [
  { no: 1, 발주처: '삼성물산(주)리조트', 품목: '안전용품', 현장명: '호텔신라외', 금액: '110,359,200' },
  { no: 2, 발주처: '일성건설(주)', 품목: '안전용품', 현장명: '가재울트루엘에코시티', 금액: '67,862,700' },
  { no: 3, 발주처: '신한열기(주)', 품목: '안전용품', 현장명: '지역난방공사외', 금액: '56,663,500' },
  { no: 4, 발주처: '두원이엔에프씨(주)', 품목: '안전용품', 현장명: '여의도파크원외', 금액: '45,032,500' },
  { no: 5, 발주처: '(주)비전엔지니어링', 품목: '안전용품', 현장명: '아산탕정삼성전자외', 금액: '36,909,100' },
  { no: 6, 발주처: '(주)효성토건', 품목: '안전용품', 현장명: '광장동사각형거공사외', 금액: '31,737,000' },
  { no: 7, 발주처: '(주)한국종합기술', 품목: '안전용품', 현장명: '부천GS파워외', 금액: '27,138,900' },
  { no: 8, 발주처: '(주)뉴보텍', 품목: '안전용품', 현장명: '정릉로하수암거현장외', 금액: '26,802,000' },
  { no: 9, 발주처: '유현기술(주)', 품목: '안전용품', 현장명: 'S-OIL 스팀배관외', 금액: '23,614,600' },
  { no: 10, 발주처: '(주)한영씨엠씨', 품목: '안전용품', 현장명: '노블카운티외', 금액: '23,494,000' },
  { no: 11, 발주처: '예간종합건설(주)', 품목: '안전용품', 현장명: '가산중학교외', 금액: '23,296,500' },
  { no: 12, 발주처: '태양방재산업주식회사', 품목: '안전용품', 현장명: '판교알파돔외', 금액: '23,105,100' },
  { no: 13, 발주처: '에스엠이서브텍(주)', 품목: '안전용품', 현장명: '리움미술관외', 금액: '18,130,000' },
  { no: 14, 발주처: '성진이앤씨(주)', 품목: '안전용품', 현장명: '기흥화성삼성전자외', 금액: '17,614,500' },
  { no: 15, 발주처: '(주)미래엔티씨', 품목: '안전용품', 현장명: '홀인초등학교외', 금액: '17,140,000' },
  { no: 16, 발주처: '솔찬조경주식회사', 품목: '안전용품', 현장명: '의정부고산대방건설외', 금액: '16,647,900' },
  { no: 17, 발주처: '에스케이임업주식회사', 품목: '안전용품', 현장명: 'SK퓨처스파크외', 금액: '16,225,000' },
  { no: 18, 발주처: '(주)금호비전', 품목: '안전용품', 현장명: '양주옥정5중학교', 금액: '15,863,500' },
  { no: 19, 발주처: '일촌나눔하우징주식회사', 품목: '안전용품', 현장명: '태릉고등학교외', 금액: '15,258,200' },
  { no: 20, 발주처: '유한회사 보승건설', 품목: '안전용품', 현장명: '강남초등학교외', 금액: '15,050,000' },
  { no: 21, 발주처: '(주)현우기업시스템', 품목: '안전용품', 현장명: '삼송1초등학교외', 금액: '14,003,000' },
  { no: 22, 발주처: '(주)신화아이앤씨', 품목: '안전용품', 현장명: '수원호매실119센터', 금액: '13,660,000' },
  { no: 23, 발주처: '샤론일렉콤(주)', 품목: '안전용품', 현장명: '진주전력지사총액공사', 금액: '13,405,000' },
  { no: 24, 발주처: '(주)네패스이앤씨', 품목: '안전용품', 현장명: '인덕지하보도외', 금액: '13,386,000' },
  { no: 25, 발주처: '그 외업체(135개)', 품목: '안전용품', 현장명: '', 금액: '404,777,870' },
] as const;

export const deliveryList2019: readonly DeliveryRow[] = [
  { no: 1, 발주처: '삼성물산(주)리조트', 품목: '안전용품', 현장명: '호텔신라외', 금액: '130,043,700' },
  { no: 2, 발주처: '(주)한국종합기술', 품목: '안전용품', 현장명: '부천GS파워외', 금액: '115,587,400' },
  { no: 3, 발주처: '(주)비젼엔지니어링', 품목: '안전용품', 현장명: '수원DC, 평택삼성전자', 금액: '105,386,200' },
  { no: 4, 발주처: '두원미에프씨(주)', 품목: '안전용품', 현장명: '여의도파크원외', 금액: '57,374,100' },
  { no: 5, 발주처: '(주)선미인터내셔널', 품목: '안전용품', 현장명: '송도현장외', 금액: '27,346,400' },
  { no: 6, 발주처: '(주)삼유이앤아이', 품목: '안전용품', 현장명: '신라호텔', 금액: '20,072,000' },
  { no: 7, 발주처: '(주)에스원', 품목: '안전용품', 현장명: '일원역사', 금액: '19,695,900' },
  { no: 8, 발주처: '금유미앤비(주)', 품목: '안전용품', 현장명: '일원역사외', 금액: '19,631,500' },
  { no: 9, 발주처: '세양조경주식회사', 품목: '안전용품', 현장명: '기배역사공원외', 금액: '19,265,500' },
  { no: 10, 발주처: '(주)유진21', 품목: '안전용품', 현장명: '영종하늘도시외', 금액: '18,543,250' },
  { no: 11, 발주처: '명정건설(주)', 품목: '안전용품', 현장명: '서울과학기술대', 금액: '17,564,500' },
  { no: 12, 발주처: '(주)금오테크', 품목: '안전용품', 현장명: 'KDHC 강남지사', 금액: '14,910,500' },
  { no: 13, 발주처: '일촌나눔하우징(주)', 품목: '안전용품', 현장명: '아이휴센터외', 금액: '14,242,500' },
  { no: 14, 발주처: '태양방재산업주식회사', 품목: '안전용품', 현장명: '삼성래미안신반포외', 금액: '13,939,900' },
  { no: 15, 발주처: '에이치지산업개발(주)', 품목: '안전용품', 현장명: '송곡여고외', 금액: '13,595,000' },
  { no: 16, 발주처: '(주)새빛전력', 품목: '안전용품', 현장명: '구리지사 저압B공사', 금액: '13,123,000' },
  { no: 17, 발주처: '대은건설 주식회사', 품목: '안전용품', 현장명: '서울고일초외', 금액: '12,515,000' },
  { no: 18, 발주처: '영조건설 주식회사', 품목: '안전용품', 현장명: '예일여고체육관공사', 금액: '12,480,000' },
  { no: 19, 발주처: '주식회사 국제전설', 품목: '안전용품', 현장명: '양평한전', 금액: '12,299,000' },
  { no: 20, 발주처: '(주)탑이엔지', 품목: '안전용품', 현장명: '분당차병원외', 금액: '12,133,000' },
  { no: 21, 발주처: '한양전기 주식회사', 품목: '안전용품', 현장명: '송전중학교외', 금액: '11,742,000' },
  { no: 22, 발주처: '(주)씨알에스기술', 품목: '안전용품', 현장명: '군포역세권외', 금액: '11,720,000' },
  { no: 23, 발주처: '세진전력(주)', 품목: '안전용품', 현장명: '노후가로등교체공사외', 금액: '11,559,000' },
  { no: 24, 발주처: '성진미앤씨(주)', 품목: '안전용품', 현장명: '화성반월사무실외', 금액: '10,945,500' },
  { no: 25, 발주처: '그 외 업체(113개)', 품목: '안전용품', 현장명: '', 금액: '275,090,773' },
] as const;

export const deliveryByYear = {
  2025: deliveryList2025,
  2024: deliveryList2024,
  2023: deliveryList2023,
  2022: deliveryList2022,
  2021: deliveryList2021,
} as const;

export type DeliveryYear = keyof typeof deliveryByYear;

export const deliveryYears: DeliveryYear[] = [2025, 2024, 2023, 2022, 2021];

/** 연도별 총 매출 표기(자료·이미지에 적힌 값 그대로, 행 금액 합산 없음) */
export const deliveryYearSalesTotals = [
  { year: 2025 as const, 총매출: '917,772,063원' },
  { year: 2024 as const, 총매출: '1,176,320,450원' },
  { year: 2023 as const, 총매출: '1,473,766,973원' },
  { year: 2022 as const, 총매출: '828,186,800원' },
  { year: 2021 as const, 총매출: '1,025,428,000원' },
] as const;
